import React, { ReactElement, ReactNode } from 'react'
import { Switch } from '@one-tree/library'
import styled from 'styled-components'
import { StateAction } from '../../../types/Aliases'

const Styles = styled.div<{ show: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${({ show }): string => (show ? 'margin-bottom: 10px' : '')};
`

type Props = {
  children: ReactNode
  show: boolean
  switchLabel: string
  switchAction: StateAction<boolean>
}
export default function PromotionSwitch(props: Props): ReactElement {
  const { children, show, switchLabel, switchAction } = props

  return (
    <Styles show={show}>
      <Switch
        label={switchLabel}
        flipLabel={true}
        value={show}
        switchAction={switchAction}
      />
      {show ? children : null}
    </Styles>
  )
}
